var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('div',[_vm._v(" "+_vm._s(_vm.params.value.name)+" "),_c('em',[_vm._v("("+_vm._s(_vm.params.value.email)+")")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }